/**
 * React Query hook for fish data viewer
 */
import { useQuery } from '@tanstack/react-query';
import { fishSpeciesApi } from '@/api/fishSpecies';
import type { FishViewerFilters } from '@/types/livestock';
import { CACHE_TIMES } from '@/config/cacheTimes';

export function useFishViewer(filters?: FishViewerFilters) {
  return useQuery({
    queryKey: ['fish-viewer', filters],
    queryFn: () => fishSpeciesApi.getViewerData(filters),
    staleTime: CACHE_TIMES.LIVE,
    retry: 2,
  });
}
